import { render } from "./ProjectManagerView.vue?vue&type=template&id=961808ee"
import script from "./ProjectManagerView.vue?vue&type=script&lang=js"
export * from "./ProjectManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__